import { Ref } from "react";

import "./storeDirectionsMap.scss";

type StoreDirectionsMapComponentProps = {
    ref?: Ref<HTMLDivElement>;
};

const StoreDirectionsMapComponent = ({
    ref
}: StoreDirectionsMapComponentProps) => {
    return (
        <div className={"store-directions-map"}>
            <div
                className="store-directions-map__map"
                ref={ref}
            ></div>
        </div>
    );
};

export { StoreDirectionsMapComponent };
